module.exports = {
  "country": "EE",
  "artist": "Thommy Cash",
  "song": "Espresso Macchiato",
  "year": "2025",
  "place": "3",
  "spotify": "4zpNfuWJA3K4d9TS4qnOIB"
};